'use strict';

function SettingsOrgBillingController ($state, $scope, $sce, $http, IntercomService, Flux, SettingsActions, PlanStore, IdentityService, AnalyticsService, AppDialogsActions) {

  const vm = this;
  vm.showSpinner = true;
  vm.canReactivate = false;
  vm.plan = {};
  vm.subscription = {};
  vm.externalCustomer = {};

  const getDaysLeftInTrial = (daysLeft) => {

    return (new Date(daysLeft) - new Date() / 1000) / (60 * 60 * 24);
  };

  /**======== Button Actions ========**/
  vm.showReactivation = (plan) => {

    SettingsActions.OpenDialog.dispatch('reactivateSubscription', {'plan': plan});
  };

  vm.openChat = () => {

    IntercomService.show();
  };

  /**======== Handle Portal Request ========**/

  vm.determineReactivation = () => {

    if (!PlanStore.get('orgPlan').isEnabled) {
      vm.canReactivate = true;
      vm.showReactivation(PlanStore.get('orgPlan'));
    }
  };

  vm.fetchedData = () => {

    vm.closeCustomerPortal(); // the portal is out of date
    vm.orgPlan = PlanStore.get('orgPlan');
    vm.plan = PlanStore.get('externalPlan');
    vm.subscription = PlanStore.get('externalSubscription');
    vm.externalCustomer = PlanStore.get('externalCustomer');

    if (vm.orgPlan.externalSubscriptionId && !!vm.plan) { // if Chargbee customer && Payments API is working
      vm.subscription.daysLeft = getDaysLeftInTrial(vm.subscription.trial_end);
    }
    else {
      vm.showSpinner = false;
    }
  };

  vm.convertToSubscription = () => {

    window.open('https://www.skycatch.com/pricing/#contact_form', '_blank')
    // vm.subscription = PlanStore.get('externalSubscription');
    // const daysLeftInTrial = getDaysLeftInTrial(vm.subscription.trial_end);
    // vm.subscription.daysLeft = daysLeftInTrial;

    // AnalyticsService.track('[CORE] Subscription', 'Enter Flow', {
    //   'remaining_days': daysLeftInTrial,
    //   'state': $state.current.name
    // });
    // AppDialogsActions.GetSelectPlanPage.dispatch();
  };

  vm.couponDialog = () => {

    SettingsActions.OpenDialog.dispatch('inputCoupon', {});
  };

  vm.changePlan = () => {

    SettingsActions.OpenDialog.dispatch('changePlan', {});
  };

  vm.activateCurrentSubscription = () => {

    vm.showReactivation(PlanStore.get('orgPlan'));
  };

  vm.viewPortal = () => {

    const OrganizationStore = Flux.Store.get('OrganizationStore');
    const url = `${IdentityService.getPaymentsApiUri()}organizations/${OrganizationStore.get('current').id}/portal`;
    const httpConfig = { url, method: 'GET' };

    return $http(httpConfig)
    .then((payload) => {

      const res = payload.data.data;
      vm.showSpinner = true;
      vm.portal = $sce.trustAsResourceUrl(res.portal_session.access_url);
      vm.activePortal = true;

      return vm.activePortal;
    })
    .catch((err) => {

      vm.showSpinner = false;
      vm.error = err.message;

      return vm.error;
    });

  };

  vm.closeCustomerPortal = () => {

    vm.activePortal = false;
  };

  vm.fetchedData();
  vm.determineReactivation();

  PlanStore.on(PlanStore.Events.Changed, vm.fetchedData.bind(this), $scope);
}

SettingsOrgBillingController.$inject = ['$state', '$scope', '$sce', '$http', 'IntercomService', 'sbFlux', 'SettingsActions', 'PlanStore', 'IdentityService', 'AnalyticsService', 'AppDialogsActions'];

module.exports = SettingsOrgBillingController;



// WEBPACK FOOTER //
// ./src/app/settings/orgBilling/SettingsOrgBillingController.js